<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="height: 100%;overflow:auto">
            <Tabs v-model="activeTab" style="margin-bottom: 20px;">
                <TabPane label="金币消耗" name="gold">
                    <div class="search-form">
                        <DatePicker 
                            type="daterange"
                            placeholder="选择时间" 
                            :value="[goldSearchForm.startDate,goldSearchForm.endDate]" 
                            transfer
                            @on-change="(e)=>{
                                if(e&&e.length){
                                    goldSearchForm.startDate=e[0];
                                    goldSearchForm.endDate=e[1]
                                }else{
                                    goldSearchForm.startDate = ''
                                    goldSearchForm.endDate = ''
                                }
                                
                            }"
                            style="width: 200px; margin-right: 10px;" 
                        />
                        <Button type="primary" @click="getGoldData()">查询</Button>
                        <Button @click="resetGoldSearch" style="margin-left:10px;">重置</Button>
                        <Button type="warning" :loading="exportLoading" @click="handleExport()" style="margin-left:10px;">导出</Button>
                    </div>
                    <Table :data="goldTableData" :columns="goldColumns" style="margin-top: 20px;"></Table>
                </TabPane>
                <TabPane label="赠币消耗" name="bonus">
                    <div class="search-form">
                        <DatePicker 
                            type="daterange"
                            placeholder="选择时间" 
                            :value="[bonusSearchForm.startDate,bonusSearchForm.endDate]" 
                            transfer
                            @on-change="(e)=>{
                                if(e&&e.length){
                                    bonusSearchForm.startDate=e[0];
                                    bonusSearchForm.endDate=e[1]
                                }else{
                                    bonusSearchForm.startDate = ''
                                    bonusSearchForm.endDate = ''
                                }
                                
                            }"
                            style="width: 200px; margin-right: 10px;" 
                        />
                        <Button type="primary" @click="getBonusData()">查询</Button>
                        <Button @click="resetBonusSearch" style="margin-left:10px;">重置</Button>
                        <Button type="warning" :loading="exportLoading" @click="handleExportBonus()" style="margin-left:10px;">导出</Button>
                    </div>
                    <Table :data="bonusTableData" :columns="bonusColumns" style="margin-top: 20px;"></Table>
                </TabPane>
                <TabPane label="VIP" name="vip">
                    <div class="search-form">
                        <DatePicker 
                            type="daterange"
                            placeholder="选择时间" 
                            :value="[vipSearchForm.startDate,vipSearchForm.expirationDate]"
                            transfer
                            @on-change="(e)=>{
                                if(e&&e.length){
                                    vipSearchForm.startDate=e[0];
                                    vipSearchForm.expirationDate=e[1]
                                }else{
                                    vipSearchForm.startDate = ''
                                    vipSearchForm.expirationDate = ''
                                }
                            }"
                            style="width: 200px; margin-right: 10px;"
                        />
                        <Button type="primary" @click="getVipData()">查询</Button>
                        <Button @click="resetVipSearch" style="margin-left:10px;">重置</Button>
                        <Button type="warning" :loading="exportLoading" @click="handleExport()" style="margin-left:10px;">导出</Button>
                    </div>
                    <Table :data="vipTableData" :columns="vipColumns" style="margin-top: 20px;">
                        <Pages slot="footer" :page="vipPage" :func="getVipData"></Pages>
                    </Table>
                </TabPane>
            </Tabs>
        </div>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getVipActiveList, getCoinRechargeList, getVipActiveListExport, getCoinRechargeListExport } from '@/api/order'

export default {
    components: {
        Pages
    },
    data() {
        return {
            exportLoading: false,
            // 激活的标签页
            activeTab: 'gold',
            
            // 金币消耗搜索表单
            goldSearchForm: {
                startDate: '',
                endDate: ''
            },
            bonusSearchForm: {
                startDate: '',
                endDate: ''
            },
            
            // 金币消耗表格数据
            goldTableData: [],
            bonusTableData: [],
            
            // 金币消耗表格列配置
            goldColumns: [
                { title: '月份', key: 'month' },
                { title: '充值金币数量', key: 'coinNum' },
                { title: '充值金币数量 - IOS', key: 'coinNumIos' },
                { title: '充值金币数量 - ANDROID', key: 'coinNumAndroid' },
                { title: '赠送金币数量', key: 'bonusNum' },
                { title: '消耗 - 赠送金币数量', key: 'bonusNumConsume' },
                { title: '过期 - 赠送金币数量', key: 'expireBonusNumConsume' },
                { title: '消耗 - 充值金币数量', key: 'coinNumConsume' },
                { title: '消耗 - 充值金币数量 - IOS', key: 'coinNumConsumeIos' },
                { title: '消耗 - 充值金币数量 - ANDROID', key: 'coinNumConsumeAndroid' }
            ],
            bonusColumns: [
                { title: '月份', key: 'month' },
                { title: '赠送金币数量', key: 'bonusNum' },
                { title: '消耗 - 赠送金币数量', key: 'bonusNumConsume' },
                { title: '过期 - 赠送金币数量', key: 'expireBonusNumConsume' },
            ],
            
            // VIP搜索表单
            vipSearchForm: {
                startDate: '',
                expirationDate: ''
            },
            
            // VIP表格数据
            vipTableData: [],
            
            // VIP分页配置
            vipPage: {
                current: 1,
                size: 10,
                total: 0
            },
            
            // VIP表格列配置
            vipColumns: [
                { title: '用户ID', key: 'userId' },
                { title: '用户主键ID', key: 'userPrimaryId' },
                { title: '订单号', key: 'orderNo' },
                { title: '商品名称', key: 'goodsName' },
                { title: '支付金额', key: 'goodsPrice' },
                { title: '支付方式', key: 'payMethod' },
                { title: '支付时间', key: 'payTime' },
                { title: 'VIP开始时间', key: 'vipOriginalTime' },
                { title: 'VIP过期时间', key: 'vipRechargedTime' }
            ]
        }
    },
    methods: {
        // 获取金币消耗数据
        getGoldData() {
            // 这里需要替换为实际的API调用
            // 模拟数据
            getCoinRechargeList({
                ...this.goldSearchForm
            }).then(r=>{
                this.goldTableData = r.data
            })
        },
        getBonusData() {
            // 这里需要替换为实际的API调用
            // 模拟数据
            getCoinRechargeList({
                ...this.bonusSearchForm
            }).then(r=>{
                this.bonusTableData = r.data
            })
        },
        
        // 重置金币消耗搜索
        resetGoldSearch() {
            this.goldSearchForm = {
                startDate: '',
                endDate: ''
            }
            // this.getGoldData()
        },
        resetBonusSearch() {
            this.bonusSearchForm = {
                startDate: '',
                endDate: ''
            }
            // this.getGoldData()
        },
        
        // 获取VIP数据
        getVipData(page) {
            if (page) this.vipPage.current = page
            else this.vipPage.current = 1
            
            // 这里需要替换为实际的API调用
            // 模拟数据
            getVipActiveList({
                ...this.vipPage,
                ...this.vipSearchForm
            }).then(r=>{
                this.vipTableData = r.data.records
                this.vipPage.total = r.data.total
            })
        },
        handleExport() {
            this.exportLoading = true
            const exportData = this.activeTab == 'gold'?getCoinRechargeListExport:getVipActiveListExport
            const searchForm = this.activeTab == 'gold'?this.goldSearchForm:this.vipSearchForm
            exportData({
                    ...searchForm,
                }).then(r => {
                    const link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = r.data.fileUrl
                    // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'), r.data.fileUrl.length)
                    link.setAttribute('download', r.data.fileName)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    this.exportLoading = false
                }).catch(e => {
                    this.exportLoading = false
                })
        },
        handleExportBonus() {
            this.exportLoading = true
            const searchForm = this.bonusSearchForm
            getCoinRechargeListExport({
                    ...searchForm,
                }).then(r => {
                    const link = document.createElement('a')
                    link.style.display = 'none'
                    link.href = r.data.fileUrl
                    // link.href = window.location.origin + r.data.fileUrl.substring(r.data.fileUrl.indexOf('/s_excel'), r.data.fileUrl.length)
                    link.setAttribute('download', r.data.fileName)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                    this.exportLoading = false
                }).catch(e => {
                    this.exportLoading = false
                })
        },
        
        // 重置VIP搜索
        resetVipSearch() {
            this.vipSearchForm = {
                startDate: '',
                expirationDate: ''
            }
            this.vipPage.current = 1
            // this.getVipData()
        }
    },
    mounted() {
        // 初始化数据
        // this.getGoldData()
        // this.getVipData()
    }
}
</script>

<style scoped lang="less">
.layout-card {
    /deep/ .ivu-card-body {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
}

.search-form {
    display: flex;
    margin-bottom: 10px;
}
</style>
